module.exports = __webpack_public_path__ + "static/media/3- 3000 prestations.2edf5781.png";